import React from 'react';
import './OverallCourseWidget.css';

const OverallCourseWidget = ({ data }) => {
  if (!data || data.length === 0) {
    return null;
  }

  // Calculate total level and progress
  const calculateStats = () => {
    let levelSum = 0;
    let progressSum = 0;

    data.forEach(subcourse => {
      const userStats = subcourse['user-stats'] || {};
      const allStats = userStats['all-stats'] || {};
      levelSum += allStats.level || 0;
      progressSum += allStats.progress || 0;
    });

    return {
      totalLevel: levelSum,
      totalProgress: progressSum,
      maxLevel: data.length * 100,
      maxProgress: data.length * 100,
    };
  };

  const stats = calculateStats();

  return (
    <div className="overall-course-widget">
      <h3 className="widget-title">Overall Course Statistics</h3>
      
      <div className="widget-content">
        <div className="stat-row">
          <span className="stat-label">Level</span>
          <span className="stat-value">{stats.totalLevel}/{stats.maxLevel}</span>
        </div>

        <div className="stat-row">
          <span className="stat-label">Progress</span>
          <div className="progress-bar-wrapper">
            <div className="progress-bar-track">
              <div 
                className="progress-bar-fill" 
                style={{ width: `${(stats.totalProgress / stats.maxProgress * 100)}%` }}
              />
            </div>
            <span className="progress-bar-text">{Math.round(stats.totalProgress / stats.maxProgress * 100)}%</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OverallCourseWidget;

